
export const team = [
    {name:'Jenny Wilson', online:true, username:'jennyq91', img:'/faces/3.png'},
    {name:'Bob Schwartz', online:true, username:'bobschwartz', img:'/faces/4.png'},
    {name:'Jane Cooper', username:'janecoops', img:'/faces/5.png'},
    {name:'Brooklyn Sympsons', username:'brook_simmons', img:'/faces/6.png'},
    {name:'Billy Cooper', username:'bcooper', online:true, img:'/faces/7.png'},
    {name:'Diane Russel', username:'dae_russ', img:'/faces/8.png'},
]